export default __webpack_public_path__ + "static/media/smart-home-energy-logo.629e9869.png";